import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {CoreApiService} from "../../../core/service/core-api.service";
import {InsuranceDocumentDto} from "../../user-insurance/types/ds-user-added-insurance.types";
import {BookingAppointmentDto, BookingDayListDto, BookingDayTimeListDto, BookingSlotDto} from "../types/bookings.types";
import {formatDate} from "@angular/common";


@Injectable({ providedIn: 'root' })
export abstract class BookingsApiService {

  endPoint: string = "mvseu/eu/bookings"

  constructor(
    protected coreApiService: CoreApiService) {
  }

  public getFreeDays(scheduleTypeId: number, startDate: Date, endDate: Date): Observable<BookingDayListDto> {
    const startDateApi = formatDate(startDate, 'yyyy-MM-dd', 'en-US');
    const endDateApi = formatDate(endDate, 'yyyy-MM-dd', 'en-US');

    return this.coreApiService.get(`${this.endPoint}/period/${scheduleTypeId}?start=${startDateApi}&end=${endDateApi}`);
  }

  public getFreeSlots(appointmentTypeId: number, date: Date): Observable<BookingSlotDto[]> {
    const dateApi = formatDate(date, 'yyyy-MM-dd', 'en-US');
    return this.coreApiService.get(`${this.endPoint}/day/${appointmentTypeId}?date=${dateApi}`);
  }

  public schedule(scheduleTypeId: number, freeSlotId: string) : Observable<BookingAppointmentDto> {
    return this.coreApiService.post({},`${this.endPoint}/schedule/${scheduleTypeId}?freeSlotId=${freeSlotId}`)
  }


}
